import React, { useRef, useEffect, useState } from 'react'
import './individual-bus-stop-selection.css'

export default function IndividualBusStopSelection({/*addBusStopToList,*/ stopName, stopId, lineColor, lineColorHex}) {

  function clickNewStation() {
    //addBusStopToList(stationName, stationId, lineColor, lineColorHex)
  }

  return (
    <div className='individual-bus-stop-selection-container' onClick={clickNewStation}>
      <div className='individual-bus-stop-selection-click-container'>
        <div className='individual-bus-stop-selection-station-art-container'>
          <div className='individual-bus-stop-selection-station-art-rounded-box'></div>
          {/* <div className='individual-bus-stop-selection-station-art-line'></div> */}
        </div>
        <div className='individual-bus-stop-selection-station-name'>
          {stopName}
        </div>
      </div>
      
    </div>
  )
}
